import { ChatStatus } from '../../chat/chat-status.enum';
var ChatChannelDataBuilder = /** @class */ (function () {
    function ChatChannelDataBuilder() {
        this.chatChannelData = {
            participantIds: [],
            activeParticipantIds: [],
            chatId: '111-000',
            chatStatus: ChatStatus.WAITING,
            chatStatusLastUpdateDate: 0,
            activeDurationsSec: [],
            waitDurationsSec: [],
            lastSessionTotalActiveDurationSec: 0,
            lastSessionTotalWaitDurationSec: 0
        };
    }
    ChatChannelDataBuilder.prototype.withParticipantIds = function (participantIds) {
        this.chatChannelData.participantIds = participantIds;
        return this;
    };
    ChatChannelDataBuilder.prototype.withActiveParticipantIds = function (activeParticipantIds) {
        this.chatChannelData.activeParticipantIds = activeParticipantIds;
        return this;
    };
    ChatChannelDataBuilder.prototype.withChatId = function (chatId) {
        this.chatChannelData.chatId = chatId;
        return this;
    };
    ChatChannelDataBuilder.prototype.withChatStatus = function (chatStatus) {
        this.chatChannelData.chatStatus = chatStatus;
        return this;
    };
    ChatChannelDataBuilder.prototype.withChatStatusLastUpdateDate = function (chatStatusLastUpdateDate) {
        this.chatChannelData.chatStatusLastUpdateDate = chatStatusLastUpdateDate;
        return this;
    };
    ChatChannelDataBuilder.prototype.withLastMessage = function (lastMessage) {
        this.chatChannelData.lastMessage = lastMessage;
        return this;
    };
    ChatChannelDataBuilder.prototype.withWaitDurationsSec = function (waitDurationsSec) {
        this.chatChannelData.waitDurationsSec = waitDurationsSec;
        return this;
    };
    ChatChannelDataBuilder.prototype.withActiveDurationsSec = function (activeDurationsSec) {
        this.chatChannelData.activeDurationsSec = activeDurationsSec;
        return this;
    };
    ChatChannelDataBuilder.prototype.withLastSessionTotalActiveDurationSec = function (lastSessionTotalActiveDurationSec) {
        this.chatChannelData.lastSessionTotalActiveDurationSec = lastSessionTotalActiveDurationSec;
        return this;
    };
    ChatChannelDataBuilder.prototype.withLastSessionTotalWaitDurationSec = function (lastSessionTotalWaitDurationSec) {
        this.chatChannelData.lastSessionTotalWaitDurationSec = lastSessionTotalWaitDurationSec;
        return this;
    };
    ChatChannelDataBuilder.prototype.build = function () {
        return this.chatChannelData;
    };
    return ChatChannelDataBuilder;
}());
export { ChatChannelDataBuilder };
//# sourceMappingURL=chat-channel-data.builder.js.map